import React, { useEffect } from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { queryClient } from '@/services/queryClient'

// Extend Window interface to include queryClient for testing
declare global {
  interface Window {
    __REACT_QUERY_CLIENT__?: typeof queryClient
  }
}

interface QueryProviderProps {
  children: React.ReactNode
}

export const QueryProvider: React.FC<QueryProviderProps> = ({ children }) => {
  // Expose queryClient on window for E2E testing (development only)
  useEffect(() => {
    if (import.meta.env.DEV) {
      window.__REACT_QUERY_CLIENT__ = queryClient
      return () => {
        delete window.__REACT_QUERY_CLIENT__
      }
    }
  }, [])

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  )
}